module.exports = __webpack_public_path__ + "img/1.fef335ad.png";